<template>
  <div class="bg-wrap">
    <div class="step1">
      <div class="box">
        <div class="tit">座位号：1</div>
        <div class="logo"><a href="javascript:void(0)"
                             class=""><img src="@/assets/images/step/logo.jpg"></a></div>
        <div class="step-con">
          <ul>
            <li><span>准考证号：</span><input type="text"
                                         value="11111111111"
                                         v-model="zkzID"></li>
            <li><span>证 件 号：</span><input type="text"
                                          value="111111111111111111"
                                          v-model="personID"></li>
          </ul>
          <div class="btn">
            <a href="javascript:void(0);"
               @click="examStart"
               class="a1"><img src="@/assets/images/step/login-btn.gif"></a>
            <a href="javascript:void(0);"><img src="@/assets/images/step/reset-btn.gif"></a>
          </div>
        </div>
        <span class="tip">说明：请使用准考证号：11111111111，证件号：111111111111111111</span>
      </div>
      <exam-start :visible.sync="tipVisible"
                  :tipInfo="tipInfo"
                  :isNext.sync="isNext"></exam-start>
    </div>
  </div>
</template>
<script>
import { getPwcExamInfo } from '@api/activity'
import { setPageTitle, parseNumber, getCookie } from '@/utils'

import ExamStart from '@/views/Activity/pwc/components/examStart'

export default {
  name: 'pwcStep1',
  components: {
    ExamStart,
  },
  data() {
    return {
      flag: 'activitySimPaper',
      activityExamID: '',
      userID: '',
      zkzID: '11111111111',
      personID: '111111111111111111',
      tipVisible: false,
      tipInfo: null,
      isNext: false, // 所有的判断完毕才能进行下一步
    }
  },
  async mounted() {
    // http://tiku.chinaacc.com:8890/mid/#/activity/pwc/realMockExam/step1?activityExamID=158
    const { activityExamID } = this.$route.query
    this.activityExamID = activityExamID
      ? parseNumber(activityExamID)
      : null
    this.userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
    this.init()
  },
  methods: {
    init() {
      let params = {
        activityExamID: this.activityExamID,
        userID: this.userID,
      }
      getPwcExamInfo(params)
        .then((res) => {
          // 考试提醒
          if (res) {
            document.title = setPageTitle(res.courseName || '会计专业技术考试')
            this.tipInfo = res
            // 试卷有可能会限制次数，有可能不限制，后端会返回一个num次数的值，如果返回是-1，前端就不展示做题次数
            if (res.isExamDate === 0 || res.num != -1) {
              this.tipVisible = true
            }
            this.isNext = true
          }
        })
        .catch((e) => {
          if (e && e.msg) {
            this.$message.error(e && e.msg)
          }
        })
    },
    examStart() {
      if (!this.isNext) {
        this.$message.warning('未查询到模考信息')
        return
      }
      this.$router.push({
        path: `/activity/cyswj/ordinaryExam`,
        query: {
          activityExamID: this.activityExamID,
          flag: this.flag,
        },
      })
      // let params = {
      //   flag: this.flag,
      //   activityExamID: this.activityExamID,
      //   userID: this.userID,
      // }
      // 查询是否有临时保存试题
      // checkTempActivityExamPaper(params).then((res) => {
      //   if (res.length > 0) {
      //     const tempData = res[0]
      //     // let _confirm = confirm(
      //     //   '请确认 ：是否继续上次未完成的试卷?\n按“确定”将打开上次的试卷\n按“取消”则打开新试卷'
      //     // )
      //     // if (_confirm) {
      //       return this.$router.push({
      //         path: '/activity/pwc/ordinaryExam',
      //         query: {
      //           flag: this.flag,
      //           activityExamID: this.activityExamID,
      //           bizID: String(tempData.bizID),
      //           spendTime: String(tempData.spendTime),
      //           temp: '2',
      //         },
      //       })
      //     // } else {
      //     //   return this.$router.push({
      //     //     path: '/activity/pwc/ordinaryExam',
      //     //     query: {
      //     //       flag: this.flag,
      //     //       activityExamID: this.activityExamID,
      //     //       spendTime: 0,
      //     //       temp: '1',
      //     //       includeTempButAbandon: '1',
      //     //     },
      //     //   })
      //     // }
      //   }
      //   return this.$router.push({
      //     path: '/activity/pwc/ordinaryExam',
      //     query: {
      //       flag: this.flag,
      //       activityExamID: this.activityExamID,
      //       temp: '1',
      //     },
      //   })
      // })
    },
  },
}
</script>

